import React, { useState } from "react";
import PropTypes from "prop-types";
import { shape, required, fromModel, when } from "@totalsoft/pure-validations";
import { useChangeTrackingLens, get } from "@totalsoft/change-tracking-react";
import { useDirtyFieldValidation } from "@totalsoft/pure-validations-react";
import { useQueryWithSimpleErrorHandling } from "hooks";
import { DOCUMENT_STATE_REASONS_QUERY } from "./queries";
import StateTransitionReasonsComponent from "./StateTransitionReasonsComponent";

const validator = fromModel(item =>
  shape({
    commentText: required |> when(item.commentRequired || false)
  })
);

const StateTransitionReasonsContainer = ({ documentId, transitionConfig, onCloseModal, onSave }) => {
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [lens] = useChangeTrackingLens({
    commentText: "",
    commentRequired: transitionConfig.commentIsMandatory
  });
  const [validation, validate] = useDirtyFieldValidation(validator);

  useQueryWithSimpleErrorHandling(DOCUMENT_STATE_REASONS_QUERY, {
    variables: { documentStateId: transitionConfig.id, documentTypeId: transitionConfig.documentTypeId },
    skip: !transitionConfig.requestReason,
    onCompleted: data => {
      setReasons(data?.documentStateReasons);
    }
  });

  const handleToggleSelectItem = reasonId => {
    let tempReasonValues;
    if (selectedReasons.length > 0) {
      tempReasonValues = selectedReasons;
    } else {
      tempReasonValues = reasons;
    }
    const values = tempReasonValues.map(z => ({
      documentStateXReasonId: z.documentStateXReasonId,
      reasonId: z.reasonId,
      description: z.description,
      selected: z.selected === undefined ? false : z.selected
    }));
    setSelectedReasons(
      values.map(reason =>
        reason.reasonId === reasonId ? Object.assign(reason, { selected: !reason.selected }) : reason
      )
    );
  };

  const handleSaveTransitionReasons = () => {
    const transitionData = lens |> get;
    if (!validate(transitionData)) {
      return;
    }
    onSave(
      documentId,
      transitionConfig.id,
      transitionData.commentText,
      selectedReasons.filter(x => x.selected).map(x => x.reasonId)
    );
  };

  return (
    <StateTransitionReasonsComponent
      transitionConfig={transitionConfig}
      reasons={reasons}
      onCloseModal={onCloseModal}
      onToggleSelectItem={handleToggleSelectItem}
      onSave={handleSaveTransitionReasons}
      validation={validation}
      lens={lens}
    />
  );
};

StateTransitionReasonsContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  transitionConfig: PropTypes.object.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

export default StateTransitionReasonsContainer;
